<template>
	<AppDropdownMenu left bottom absolute v-bind="$attrs" min-width="230" v-on="$listeners" :nudge-bottom="14" :items="filteredMenuItems">
		<template #activator>
			<AnemicButton tile class="flex-centerize menu-button">
				<SIcon name="project-menu-three-dots" class="menu-icon" :width="2" :height="13" />
			</AnemicButton>
		</template>
	</AppDropdownMenu>
</template>

<script>
export default {
	name: 'GroupOptionsDropdown',
	components: {},
	props: {
		isSyncedGroup: { type: Boolean },
	},
	computed: {
		filteredMenuItems() {
			return this.menuItems.filter((item) => this.isSyncedGroup || !item.syncedGroupsOnly);
		},
	},
	watch: {},
	methods: {
		delete() {
			this.$emit('delete');
		},
		makeGroupManual() {
			this.$emit('make-group-manual');
		},
		rename() {
			this.$emit('rename');
		},
	},
	data() {
		return {
			menuItems: [
				{ text: 'Rename', onClick: this.rename },
				{ text: 'Stop sync and turn into manual group', onClick: this.makeGroupManual, syncedGroupsOnly: true },
				{ text: 'Delete', onClick: this.delete },
			],
		};
	},
};
</script>

<style scoped lang="scss">
.menu-button {
	width: 36px !important;
	height: 36px !important;
	padding: 0px !important;
	border-radius: 8px !important;
	background: var(--white) !important;
	border: 1px solid var(--border-color) !important;
	.menu-icon {
		margin-top: 1px;
		margin-left: -4px;
	}
	&:hover {
		border: 1px solid var(--forth-border-color);
	}
}
</style>
